import { render, staticRenderFns } from "./InplaySingle.vue?vue&type=template&id=2bbd4ee7&scoped=true"
import script from "./InplaySingle.vue?vue&type=script&lang=js"
export * from "./InplaySingle.vue?vue&type=script&lang=js"
import style0 from "./InplaySingle.vue?vue&type=style&index=0&id=2bbd4ee7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbd4ee7",
  null
  
)

export default component.exports